import React, { Component } from 'react';
import classNames from 'classnames';
import qs from 'qs';
import {
  Render,
  Section,
  Pagination,
  Spinner,
  Image,
  withLazyLoad,
  withSrcSets,
  withSearch,
  Sensors,
} from '../../platformui';

const LazyLoadImage = withSrcSets(withLazyLoad(Image));

const PinboardItem = (props) => {
  const itemClass = classNames({
    'c-pinboard__item': true,
    'c-pinboard__item--theme-faq': props.Theme === 'faq',
    'c-pinboard__item--theme-story': props.Theme === 'story',
    'c-pinboard__item--theme-pod': props.Theme === 'podcast',
    'c-pinboard__item--theme-forum': props.Theme === 'forum',
    'c-pinboard__item--has-image': props.Image,
    'c-pinboard__item--is-async': !props.Url,
    //Add theme article, forum and podcast
  });

  const lastItem = props.isLast ? (
    <span id="search-list-last" tabIndex="-1" />
  ) : null;

  return (
    <div className={itemClass}>
      {props.Url ? (
        <a
          href={props.Url}
          aria-label={props.Heading}
          className="c-pinboard__item-inner"
        >
          {props.Image && (
            <div className="c-pinboard__item__image">
              <LazyLoadImage
                className="c-pinboard__item__image__bg"
                isBackgroundImage={true}
                CurrentPageProps={props.CurrentPageProps}
                DefaultPreset={{ name: 'preset_600' }}
                ImageUrl={props.Image}
                Alt={props.ImageDescription}
                Sizes={{
                  sizes:
                    '(min-width: 1025px) 407px, (min-width: 640px) calc(100vw / 3), 100vw',
                }}
              />
            </div>
          )}

          <div className="c-pinboard__item-inner__theme-icon">
            <span className="c-pinboard__item__category">{props.Vignette}</span>
            <div className="c-pinboard__item-inner-container">
              <div className="c-pinboard__item-content">
                <h3 className="c-pinboard__item__heading">{props.Heading}</h3>
                <div className="c-pinboard__item__text">{props.Text}</div>
              </div>
            </div>
          </div>
          <span className="c-pinboard__item__link" />
        </a>
      ) : (
        <div className="c-pinboard__item-inner" />
      )}

      {lastItem}
    </div>
  );
};

class Pinboard extends Component {
  render() {
    const { SearchResult, Heading, CurrentPageProps, Categories } = this.props;
    if (!SearchResult) return null;
    const { SearchHits } = SearchResult;
    if (!SearchHits || SearchHits.length <= 0) return null; // Can happen if Find is not responding.

    const pinboardClasses = classNames({
      'c-pinboard': true,
      'is-loading': SearchResult.isLoading,
    });

    return (
      <Section>
        <div className="row">
          <div className="columns">
            <header className="c-section__header c-section__header--heading-shown">
              <h2 className="c-section__heading">
                {Render.Property(Heading, 'Heading')}
              </h2>
            </header>
          </div>
        </div>
        {SearchHits && SearchHits.length > 0 && (
          <div className="row">
            <div className="medium-centered medium-10 large-12 columns">
              <div className="row">
                <div className={pinboardClasses}>
                  <div className="c-pinboard__items" aria-live="polite">
                    {SearchHits.map((item, index) => (
                      <PinboardItem
                        key={index}
                        CurrentPageProps={CurrentPageProps}
                        {...item}
                        isLast={index + 1 === SearchHits.length}
                      />
                    ))}
                  </div>
                  {SearchResult.NextPage && (
                    <div className="c-pinboard__footer">
                      <Pagination
                        {...SearchResult}
                        Categories={Categories}
                        onClick={() =>
                          document.getElementById('search-list-last').focus()
                        }
                        Spinner={
                          <Spinner Modifiers={{ 'c-spinner--search': true }} />
                        }
                      >
                        {SearchResult.BatchText}
                      </Pagination>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </Section>
    );
  }
}

const withAsyncPinboard = (WrappedComponent) => {
  return class AsyncPinboard extends Component {
    state = { fetched: false };
    componentDidUpdate() {
      // Check that we have not fetched before
      if (!this.state.fetched && this.props.Async && this.props.isViewed) {
        const theme = !this.props.Theme ? '' : `&theme=${this.props.Theme}`;
        const categories = !this.props.Categories.length
          ? ''
          : `&${qs.stringify({ category: this.props.Categories })}`;
        const componentName = `componentname=${this.props.ComponentName}`;
        const searchUrl = `${componentName}${categories}${theme}`;
        this.setState(
          {
            fetched: true,
          },
          () => this.props.Search(searchUrl)
        );
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };
};

export default Sensors.Viewport(
  withSearch(withAsyncPinboard(Pinboard), 'Pinboard')
);
